// hooks/email/useSaleEmail.ts

import useApiErrorHandler from '../useApiErrorHandler';
import useLoading from '../useLoading';

import SaleEmailService from '../../services/email/SaleEmailService';
import useModals from '../useModals';

export const useSaleEmail = () => {
    const { openModal } = useModals();

    const { handle } = useApiErrorHandler();
    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    const sendSaleEmail = async (
        saleId: number
    ) => {
        try {
            showLoadingIndicator();

            const response =
                await SaleEmailService.sendSaleEmail(
                    saleId
                );

            openModal(
                response.type,
                { title: response.title, message: response.message }
            );

            return true;

        } catch (error) {

            handle(error);

            return false;

        } finally {

            hideLoadingIndicator();

        }
    };

    return {
        sendSaleEmail,
    };
};

export default useSaleEmail;